import 'promise-polyfill';
import initLightHub from '@alife/lighthub';

// @ts-ignore
// import redfox from '@ali/ncom-speedy2-redfox';

import '@ali/lib-mtop';

import {findParent, matchAll} from "./utils";


const PREFETCH_PARAMS_OBJ = {
    "data": {
        "modelId": 317,
        "device": "native",
        "endpoint": "wap",
        "envStatus": "ONLINE",
        "appKey": "vee8meczxjj3hugfjlmg0t4zh4skimd3",
        "appName": "asinHomePage",
        "deliveryId": "$deliveryId$",
        "categoryIds": "$categoryIds$",
        "companyIds": "$companyIds$",
        "level2CategoryIds": "$level2CategoryIds$",
        "topOfferIds": "$topOfferIds$",
        "tab": "$tab$",
        "currentLanguage": "$currentLanguage$",
        "currentCurrency": "$currentCurrency$",
        "currentRegion": "$currentRegion$",
        "path": "$path$",
        "uuid": "$uuid$",
        "areaId": "$areaId$",
        "deliveryBomId": "$deliveryBomId$",
        "cardId": "$cardId$",
    },
    "api": "https://insights.alibaba.com/openservice/gatewayService",
    "v": "1.0",
    "ecode": 0
};
const PREFETCH_PARAMS_OBJ_DACU = {
    ...PREFETCH_PARAMS_OBJ,
    data: {
        ...PREFETCH_PARAMS_OBJ.data,
        "deliveryBomId": "$deliveryBomId$",
        "cardId": "$cardId$",
    }
};

const PREFETCH_PARAMS_STR = decodeURIComponent(JSON.stringify(PREFETCH_PARAMS_OBJ));
const PREFETCH_PARAMS_DACU_STR = encodeURIComponent(JSON.stringify(PREFETCH_PARAMS_OBJ_DACU))

const TEST_PAGE_URL = '/pages/ddwhiex3z/index.html';

// @ts-ignore
const redfox = require('@ali/ncom-speedy2-redfox');

function logOnDebug(...args: any[]) {
    if (location.search.indexOf('__debug_lh__') !== -1) {
        console.log('[LightHub Script]', ...args);
    }
}

logOnDebug('Lh script load');

/**
 * 补全通用 prefetchX 参数
 * @param url
 */
export function normalizeUrl(url: string) {
    if (url[0] === '/') {
        url = 'https:' + url;
    }
    if (url.indexOf('m.alibaba.com/marketing/pages/') === -1) {
        return url;
    }
    const urlInfo = redfox.$helper.url.parse(url);

    urlInfo.query.wh_prefetch = url.indexOf(TEST_PAGE_URL) !== -1 ? PREFETCH_PARAMS_STR: PREFETCH_PARAMS_DACU_STR;

    return redfox.$helper.url.stringify(urlInfo);
}


/**
 * Covert URL with m.alibaba.com domain
 * m-sale.alibaba.com/xxx => m.alibaba.com/marketing/xxx
 * air.alibaba.com/xxx => m.alibaba.com/air/xxx
 * @param url
 * @returns string|boolean 返回 m.alibaba.com 转发的 URL，如果不能转发，则返回 false
 */
function convertURLToMAlibaba(url: string) {
    if (new RegExp('//m.alibaba.com/(marketing|air)/.*?', '').test(url)) {
        return normalizeUrl(url);
    } else if (new RegExp('//m-sale.alibaba.com/','').test(url)) {
        return normalizeUrl(url.replace('//m-sale.alibaba.com/', '//m.alibaba.com/marketing/'));
    } else if (new RegExp('//sale.alibaba.com/','').test(url)) {
        return normalizeUrl(url.replace('//sale.alibaba.com/', '//m.alibaba.com/marketing/'));
    } else if (new RegExp('//air.alibaba.com/','').test(url)) {
        return url.replace('//air.alibaba.com/', '//m.alibaba.com/air/');
    } else {
        return false;
    }
}


function safeJSONParse(str: string | null) {
    try {
        return JSON.parse(str as string);
    } catch(e){
    }
    return {};
}

function safeSetLocalStorageItem(key: string, value: any) {
    try {
        localStorage.setItem(key, value);
    } catch(e) {
        // 大概率是满了，清除掉里面的 page_cache 和 preload
        Object.keys(localStorage).forEach(function(key){
            localStorage.removeItem(key);
        });
    }
}

/**
 *
 * @param options PrefetchX Option
 */
function prefetchxOptionToFetchOption (option: any) {
    for (let key of Object.keys(option.data)) {
        const value = option.data[key];
        // @ts-ignore
        if (value[0] === '$' || value[0] === '@') {
            option.data[key] = {
                detectable: true,
                expression: [ value ]
            };
        }
    }

    return {
        apiConfig: option,
    }
}

/**
 * 从带 wh_prefetch 的 URL 上生成 $fetch 需要的参数
 * @param url
 */
function generateFetchOptionFromURL(url: string) {
    const urlInfo = redfox.$helper.url.parse(normalizeUrl(url));
    const paramStr = decodeURIComponent(urlInfo.query && urlInfo.query.wh_prefetch || '');
    if (paramStr) {
        const params = JSON.parse(paramStr);
        const fetchOption = prefetchxOptionToFetchOption(params);
        const finalParams = redfox.$helper.fetch.analysisConfig(fetchOption, urlInfo.query);

        if (finalParams) {

            const finalOptions = {
                apiConfig: fetchOption.apiConfig,
                params: finalParams.params,
                onError: (result: any)=>{
                    console.log('API Error');
                },
            };

            return finalOptions;
        }
    }
    return null;
}


// @ts-ignore
if (!(window._LIGHTHUB && window._LIGHTHUB.isInited)) {
    const LightHub = initLightHub();

    LightHub.exposeGlobal(['Redfox', /^mtopjsonp.*/, /^jsonp_/]);

    const ignored = [
        '//s.alicdn.com/@g/??mtb/lib-promise/3.1.3/polyfillB.js,mtb/lib-mtop/2.4.1/mtop.js,mtb/lib-login/1.5.6/login.js,mui/jsonp/5.0.6/index.js',
        '//s.alicdn.com/@g/??mtb/lib-promise/3.1.3/polyfillB.js,mtb/lib-mtop/2.4.1/mtop.js,mtb/lib-login/1.5.6/login.js',
        '//s.alicdn.com/@g/mtb/lib-mtop/2.3.15/mtop.js'
    ];

    LightHub.ignoreScript(ignored);

    const isJSONP = (tag: HTMLElement) => {
        const src = tag.getAttribute('src') || '';
        return src.indexOf('/h5/mtop.icbu.buyer.gateway') !== -1 || src.indexOf('insights.alibaba.com/openservice/gatewayService') !== -1;
    };

    LightHub.setIsJSONP(isJSONP);

    // const loadScriptThenIgnore = async (url: string) => {
    //     const tag = document.createElement('script');
    //     tag.crossOrigin = '';
    //     tag.src = url;
    //     tag.onload = () => {
    //         logOnDebug('Load script', url);
    //         LightHub.ignoreScript([ url ]);
    //     };
    //     document.head.appendChild(tag);
    // };


    const getCache = (url: string) => {
        const cacheKey = 'lighthub_page_' + pageCacheKey(url);
        const cache = safeJSONParse(localStorage.getItem(cacheKey));
        if (cache && cache.downloadTimestamp + cache.cacheAge > new Date().getTime()) {
            return cache.response;
        }
    };

    const fetchPageWithCache = (url: string) => {
        const cacheKey = 'lighthub_page_' + pageCacheKey(url);
        const cache = getCache(url);

        const fetchPage = () => LightHub.fetchUrlAndPrefetchAssets(url).then((text: string) => {
            safeSetLocalStorageItem(cacheKey, JSON.stringify({
                response: text,
                cacheAge: 60 * 60 * 24, // 1 day
                downloadTimestamp: new Date().getTime(),
            }));

            // const JS_REGEX = /<script src=\"(.*?)\"/g;
            //
            // const alljs = Array.from(matchAll(text, JS_REGEX)).filter(item => {
            //     return item.indexOf('@g/??') !== -1;
            // });
            // alljs.forEach(loadScriptThenIgnore);

            return text;
        });

        const res = fetchPage();
        if (cache) {
            return Promise.resolve(cache);
        } else {
            return res;
        }
    };


    const SKELETON_IMG = 'https://s.alicdn.com/@img/tfs/TB1BALCtRr0gK0jSZFnXXbRRXXa-1125-2436.png_500x500.jpg';

    new Image().src = SKELETON_IMG;

    // const weeklydealPrefetch = LightHub.fetchUrlAndPrefetchAssets('https://m.alibaba.com/air/apps/alimsc/sc-alibaba-weeklydeals/index.html');
    const pageCaches = {} as {
        [path: string]: Promise<string>,
    };

    const urlList = [
        // 预热主会场
        // '/pages/dzyvstxc9/index.html',
        // '/pages/new_arrivals/index.html',
        // '/apps/alimsc/sc-alibaba-weeklydeals/index.html',
        // '/apps/alimsc/sc-alibaba-product-ranklist/index.html'
        // '//m.alibaba.com/marketing/pages/dzyvstxc9/index.html',
        // '//m.alibaba.com/marketing/pages/oemnew/index.html',
        // '//m.alibaba.com/air/apps/alimsc/sc-alibaba-weeklydeals/index.html'
        // 'https://m.alibaba.com/marketing/pages/new_arrivals/index.html'
    ];

    const pageCacheKey = (url: string) => {
        const urlInfo = redfox.$helper.url.parse(convertURLToMAlibaba(url));
        return urlInfo.host + urlInfo.path;
    };


    const matchPage = (url: string) => {
        if (typeof url !== 'string') return false;

        for (let item of urlList) {
            if (url.indexOf(item) !== -1) {
                return true;
            }
        }
        return false;
    };


    // 提前预加载页面

    for (let url of urlList) {
        const cacheKey = pageCacheKey(url);
        if (pageCaches[cacheKey]) {
            continue;
        }
        if (url.indexOf('/air/apps/alimsc/sc-alibaba-weeklydeals') === -1) {
            url += '?simplify=1';
        }
        pageCaches[cacheKey] = fetchPageWithCache(url);
    }

    const buyNowEnReg = /^https:\/\/m\.alibaba.com\/contract\/nowBuy\.htm/
    const buyNowOtherReg =/^https:\/\/m\.[a-z]{2,10}\.alibaba.com\/contract\/nowBuy\.htm/
    const orderListEnReg = /^https:\/\/m\.alibaba.com\/ta\/list\/scene\/mList\.htm/
    const orderListOtherReg =/^https:\/\/m\.[a-z]{2,10}\.alibaba.com\/ta\/list\/scene\/mList\.htm/
    const matchNowBuy = (url: string) => {
        return buyNowEnReg.test(url) || buyNowOtherReg.test(url)
    }
    const matchOrderList = (url: string) => {
        return orderListEnReg.test(url) || orderListOtherReg.test(url)
    }

    const locationAssign = (url: string) => {
        try {
            if (matchNowBuy(url) || matchOrderList(url)) {
                LightHub.navigateTo(url);
                return;
            }
            const finalUrl = convertURLToMAlibaba(url);
            if (typeof finalUrl === 'string' && matchPage(finalUrl)) {
                LightHub.navigateTo(finalUrl);
            } else {
                location.href = url;
            }
        } catch (e) {
            location.href = url;
        }
    };

    // @ts-ignore
    window._locationAssign = locationAssign;



    interface StringValue {
        value: string;
    }
    const urls = [] as StringValue[];

    const start = () => {
        logOnDebug('Urls under control', urls);

        if (localStorage && urls.length > 0 && location.pathname === '/') {
            safeSetLocalStorageItem('web_shared_api_home', JSON.stringify(urls));
        }
        // @ts-ignore
        window.Redfox = redfox;

        function findCacheForUrl(url: string) {
            const cacheKey = pageCacheKey(url);
            return pageCaches[cacheKey];
        }

        const hackHTML = (text: string) => {
            return text.replace(/<\/head>/, `<script>window.$flasherGroup='LEVEL_TEMPLATE_DATA';</script></head>`);
        };
        // 下单页
        LightHub.registerPage({
            id: 'nowbuy',
            match(url) {
                return matchNowBuy(url);
            },
            skeletonElement(url) {
                const div = document.createElement('div');
                div.innerHTML = `<img src="${SKELETON_IMG}"></img>`;
                return div.children[0] as HTMLElement;
            },
            entry(url) {
                return fetch(url).then(res => res.text()).then(text => hackHTML(text));
            },
        });
        // 订单列表页
        LightHub.registerPage({
            id: 'orderList',
            match(url) {
                return matchOrderList(url);
            },
            skeletonElement(url) {
                const div = document.createElement('div');
                div.innerHTML = `<img src="${SKELETON_IMG}"></img>`;
                return div.children[0] as HTMLElement;
            },
            entry(url) {
                return fetch(url).then(res => res.text()).then(text => hackHTML(text));
            },
            beforeNavigation(url) {
                // @ts-ignore
                const redfox = window.Redfox;
                // wh_prefetch
                try {
                    // const option = generateFetchOptionFromURL(url);
                    // console.log(option)
                    // debugger
                    // const urlInfo = redfox.$helper.url.parse(url);
                    // const finalOptions = redfox.$helper.fetch.analysisConfig(option, urlInfo.query);
                    // logOnDebug('prefetchx', finalOptions);
                    let api = {
                        apiName: "https://biz.alibaba.com/list/ajax/ta/main.json?platformType=H5",
                        type: "jsonp"
                    }
                    let data = { json: "%7B%22params%22%3A%7B%22filterItems%22%3A%5B%22orderStatus%40all%22%5D%2C%22orderType%22%3A%22trade_assurance%22%7D%2C%22pagination%22%3A%7B%22currentPage%22%3A1%2C%22pageSize%22%3A10%7D%2C%22requestEnvironment%22%3A%7B%22operator%22%3A%7B%22role%22%3A%22buyer%22%7D%2C%22businessType%22%3A%22taList_main%22%7D%7D"}
                    let option = {
                        apiConfig: {
                            api: {
                                web: api,
                                weex: api,
                            },
                            data: data
                        },
                        onError: function(err) {
                            console.log(err)
                        },
                        onSuccess: function(err) {
                            console.log(err)
                        },
                    }
                    redfox.$fetch(option, true);
                } catch(e) {
                }
            }
        });

        LightHub.registerPage({
            id: 'PrefetchxPage',
            match(url) {
                return matchPage(convertURLToMAlibaba(url));
            },
            skeletonElement(url) {
                const div = document.createElement('div');
                div.innerHTML = `<img src="${SKELETON_IMG}"></img>`;
                return div.children[0] as HTMLElement;
            },
            entry(url) {
                const res = findCacheForUrl(url);
                if (res) {
                    logOnDebug('hit page cache', res);
                    return res.then(text => hackHTML(text));
                } else {
                    logOnDebug('miss page cache', {url, cacheKey: pageCacheKey(url), pageCacheKey});
                }

                return fetch(url).then(res => res.text()).then(text => hackHTML(text));
            },
            updateUrl(url) {
                url = normalizeUrl(url);
                const urlInfo = redfox.$helper.url.parse(url);
                const cache = findCacheForUrl(url);
                urlInfo.query.lh_hitcache = cache ? 'yes': 'no';
                urlInfo.query['wh_prefetch'] = '{}';
                return redfox.$helper.url.stringify(urlInfo);
            },
            beforeNavigation(url) {
                // @ts-ignore
                const redfox = window.Redfox;
                // wh_prefetch
                try {
                    const option = generateFetchOptionFromURL(url);
                    const urlInfo = redfox.$helper.url.parse(url);
                    const finalOptions = redfox.$helper.fetch.analysisConfig(option, urlInfo.query);

                    logOnDebug('prefetchx', finalOptions);
                    redfox.$fetch(option, true);
                } catch(e) {
                }
            }
        });
    };

    start();

    document.addEventListener('click', (e) => {
        try {
            // @ts-ignore
            const link = findParent('a', e.target) as HTMLAnchorElement;
            if (link && matchPage(link.href)) {
                e.preventDefault();
                LightHub.origins._setTimeout.call(window,() => {
                    locationAssign(link.href);
                }, 0);
            }
        } catch(e) {
            // cancel prevent default
            e.returnValue = true;
        }
    });

    const withoutRequireCache = (cb: any) => {
        const buffer = {} as any;
        // @ts-ignore
        const cache = require.cache;

        for (let key of Object.keys(cache)) {
            buffer[key] = cache[key];
            delete cache[key];
        }

        cb();

        for (let key of Object.keys(buffer)) {
            if (!cache[key]) {
                cache[key] = buffer[key];
            }
        }
    };

    document.addEventListener("lighthubafterback", function() {
        // @ts-ignore
        delete window.Redfox;
        // @ts-ignore
        // Rax 塞进来的奇怪的状态，删掉否则会死循环
        delete document.body._r;
        // @ts-ignore
        delete document.body.$$instance;

        withoutRequireCache(() => {
            // @ts-ignore
            const next = require('@ali/ncom-speedy2-redfox');
            // @ts-ignore
            window.Redfox = next;
        });
    });




}
